// custom.js
$(document).ready(function () {

  var queue = [];
  var getSubscriptionId = '';
  var isProcessing = false;

  function setAddingState() {
    $('.add-product-bundle-subscription-btn')
      .text('Adding...')
      .css({
        pointerEvents: 'none',
        opacity: '0.6'
      });
  }

  function resetAddingState() {
    $('.add-product-bundle-subscription-btn')
      .text('Add to cart')
      .css({
        pointerEvents: 'auto',
        opacity: '1'
      });
  }

  
  function randomNumber(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min + Date.now();
  }

  /* ===============================
     ADD SUBSCRIPTION CHILD PRODUCTS
  =============================== */
  function addBundleSubscription_product() {

   
    if (queue.length === 0) {
      isProcessing = false;
      resetAddingState();
      window.location.href = "/cart";
      return;
    }

    var request = queue.shift();

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: {
        id: request.variantId,
        quantity: request.variantQty,
        selling_plan: request.selling_plan,
        properties: {
          SubscriptionId: getSubscriptionId
        }
      },
      success: function () {
        addBundleSubscription_product();
      },
      error: function () {
        isProcessing = false;
        resetAddingState();
        alert('Error while adding bundle items.');
      }
    });
  }

  /* ===============================
     ADD ONETIME CHILD PRODUCTS
  =============================== */
  function addBundleOnetime_product() {

    if (queue.length === 0) {
      mainProductAdd(); // ✅ add main product LAST
      return;
    }

    var request = queue.shift();

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: {
        id: request.variantId,
        quantity: request.variantQty,
        properties: {
          OneTime: getSubscriptionId
        }
      },
      success: function () {
        addBundleOnetime_product();
      },
      error: function () {
        isProcessing = false;
        resetAddingState();
        alert('Error while adding bundle items.');
      }
    });
  }

  /* ===============================
     ADD MAIN PRODUCT (ONETIME)
  =============================== */
  function mainProductAdd() {

    var getMainProId = $('.add-product-bundle-subscription-btn').attr('data-mainProId');

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: {
        id: getMainProId,
        quantity: 1,
        properties: {
          OneTime: getSubscriptionId
        }
      },
      success: function () {
        isProcessing = false;
        resetAddingState();
        window.location.href = "/cart";
      },
      error: function () {
        isProcessing = false;
        resetAddingState();
        alert('Error while adding product.');
      }
    });
  }

  /* ===============================
     ADD TO CART CLICK
  =============================== */
  $(document).on('click', '.add-product-bundle-subscription-btn', function (e) {
    e.preventDefault();

    if (isProcessing) return false;
    isProcessing = true;

    setAddingState(); // ✅ UX feedback

    queue = [];
    getSubscriptionId = randomNumber(1, 100);

    // Validation
    if (!$('.select-enable').length) {
      isProcessing = false;
      resetAddingState();
      $('#warning_msg')
        .text('Please select the required quantity.')
        .show();

      setTimeout(function () {
        $('#warning_msg').hide();
      }, 2500);

      return false;
    }

    var getMainProId = $(this).attr('data-mainProId');

    /* ===============================
       BUILD QUEUE
    =============================== */
    $('.vaariantAsflover').each(function () {
      $(this).find('.variant_list').each(function () {
        var addedQty = Number($(this).attr('data-added-qty'));
        if (addedQty > 0) {
          queue.push({
            variantId: $(this).find('input[type="hidden"]').val(),
            variantQty: $(this).find('.quantity option:selected').val()
          });
        }
      });
    });

    /* ===============================
       SUBSCRIPTION FLOW
    =============================== */
    if ($('.appstle_include_dropdown').length) {

      var optionId = $('[data-type="add-to-cart-form"] .appstle_select').val();

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: {
          id: getMainProId,
          quantity: 1,
          selling_plan: optionId,
          properties: {
            SubscriptionId: getSubscriptionId
          }
        },
        success: function () {
          addBundleSubscription_product();
        },
        error: function () {
          isProcessing = false;
          resetAddingState();
          alert('Error while adding main product.');
        }
      });

    } else {
      /* ===============================
         ONETIME FLOW
      =============================== */
      addBundleOnetime_product();
    }

  });

  /* ===============================
     REMOVE WHOLE BUNDLE (CART)
  =============================== */
  $(document).on('click', '.bundle_subscription_remove', function (e) {
    e.preventDefault();

    var updates = {};
    var uid = $(this).closest('.cart-form-item').attr('data-uid');

    $('.cart-form-item[data-uid="' + uid + '"]').each(function () {
      updates[$(this).attr('data-item-key')] = 0;
    });

    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      dataType: 'json',
      data: { updates: updates },
      success: function () {
        location.reload();
      }
    });
  });

});
